import StoreDetailedReport from "./StoreDetailedReport";

const Inventory: React.FC = () => {
  return <StoreDetailedReport />;
};

export default Inventory;
